import { useState, useEffect } from "react"
import {
  Card,
  CardContent,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Grid,
  Avatar,
  Chip,
  IconButton,
  Alert,
  Stack,
  Box,
  Snackbar,
} from "@mui/material"
import {
  Edit as EditIcon,
  Visibility as VisibilityIcon,
  Warning as WarningIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  AccessTime as AccessTimeIcon,
  Upload as UploadIcon,
} from "@mui/icons-material"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import PinPad from "../../PinPad/PinPad"
import { useSelector } from "react-redux"
import { format, parseISO } from "date-fns";
import { merchantKYCStatusUpdate, userKYCStatusUpdate } from "../../../util/API/KYC_new"
import CustomAlert from "../../UI/CustomAlert/CustomAlert"
import ImageViewerModal from "./ImageViewerModal"
import CustomInputAlert from "../../UI/CustomInputAlert/CustomInputAlert"
import { CircularProgress, Backdrop } from "@mui/material";
import PlaceHolderImage from "../../../images/profile-placeholder.jpg";

const DocumentCard = ({
  document,
  onEdit,
  onSave,
  onMarkExpired,
  onUploadNew,
  onStatusUpdate, // Add this new prop
  countries,
  states,
  getStatesForCountry,
  isEditing = false,
  subtypeLookup = {},
  documentImagesMap = {},
  setSelectedSubTypeId,
  getUserKycData,
  setIsStatusUpdating,
  activeTab
}) => {
  const [editingDoc, setEditingDoc] = useState(null)
  const [imageError, setImageError] = useState(false)
  const [showPinPad, setShowPinPad] = useState(false);
  const [submittedEditData, setSubmittedEditData] = useState({});
  const [showStatusUpdatePinPad, setShowStatusUpdatePinPad] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [errorAlert, setErrorAlert] = useState({
    showAlert: false,
    message: '',
    severity: '',
    header: ''
  })
  
  const [isKycInfoAdded, setIsKycInfoAdded] = useState(document.isKycInfoAdded || false)
  const [validationErrors, setValidationErrors] = useState({})
  const [shouldDisableAllFields, setShouldDisableAllFields] = useState(false)
  const [notification, setNotification] = useState({ open: false, message: "", severity: "success" })

  const [availableStates, setAvailableStates] = useState([]) // Add state for available states
  const [imageViewerOpen, setImageViewerOpen] = useState(false)
  const [showInputAlert, setShowInputAlert] = useState(false);
  const [rejectNoteContent, setRejectNoteContent] = useState("");

  const user = useSelector((state) => state.usersList.userID);
  let agent = JSON.parse(sessionStorage.getItem("user")).payload.body;

  // console.log("availableStates=========",availableStates);
  console.log("document=========",document);
  console.log("activeTab=========",activeTab);

  const validateFields = () => {
    const errors = {}
    if (!editingDoc?.number) errors.number = "Document Number is required"
    if (!editingDoc?.issueDate) errors.issueDate = "Issue Date is required"
    if (!editingDoc?.expiryDate) errors.expiryDate = "Expiry Date is required"
    if (!editingDoc?.country) errors.country = "Country is required"
    if (!editingDoc?.state) errors.state = "State is required"
    console.log("ValidationErrors===========",errors);
    setValidationErrors(errors)
    return Object.keys(errors).length === 0
  }

  // Add this useEffect after the existing useState declarations
  useEffect(() => {
    if (editingDoc && editingDoc.country) {
      const states = getStatesForCountry(editingDoc.country)
      setAvailableStates(states)

      // Reset state selection if current state is not available in new country
      if (editingDoc.state && !states.find((state) => state.value === editingDoc.state)) {
        setEditingDoc((prev) => ({ ...prev, state: "" }))
      }
    } else {
      setAvailableStates([])
    }
  }, [editingDoc])

  useEffect(() => {
  if (document && document.country) {
      const states = getStatesForCountry(document.country)
      setAvailableStates(states)

      // Reset state selection if current state is not available in new country
      // if (editingDoc.state && !states.find((state) => state.value === editingDoc.state)) {
      //   setEditingDoc((prev) => ({ ...prev, state: "" }))
      // }
    } else {
      setAvailableStates([])
    }
  }, [document])

  const isValidBase64Image = (str) => {
    if (!str || typeof str !== "string") return false

    // Check if it's a data URL
    if (str.startsWith("data:image/")) {
      const base64Part = str.split(",")[1]
      if (!base64Part) return false

      // Basic base64 validation
      const base64Regex = /^[A-Za-z0-9+/]*={0,2}$/
      return base64Regex.test(base64Part) && base64Part.length > 0
    }

    return false
  }

  const getSubtypeDisplayName = () => {
    // Use subTypeDisplay if provided, otherwise lookup by subType ID
    if (document.subTypeDisplay) {
      return document.subTypeDisplay
    }
    if (subtypeLookup[document.subType]) {
      return subtypeLookup[document.subType].name
    }
    // Fallback to subType value (could be ID or name)
    return document.subType
  }

  // Helper function to clean base64 string by removing metadata suffix
  // const cleanBase64String = (str) => {
  //   if (!str || typeof str !== "string") return str

  //   // Remove patterns like |png|, |jpg|, |jpeg|, |gif|, etc. from the end
  //   return str.replace(/\|[a-zA-Z0-9]+\|$/g, "")
  // }
  const cleanBase64String = (str) => {
    if (!str || typeof str !== "string") return str;
  
    // Remove 'data:image/...;base64,' prefix if present
    let cleaned = str.replace(/^data:image\/[a-zA-Z]+;base64,/, "");
  
    // Remove custom suffix like |png| or |png (even if pipe is missing at the end)
    cleaned = cleaned.replace(/\|[a-zA-Z0-9]+(\|)?$/, "");
  
    return cleaned;
  };

  // Helper function to get the actual document image
  const getDocumentImage = () => {
    let imageData = null

    // First try to get image from the fetched images map
    if (document.documentImageId && documentImagesMap[document.documentImageId]) {
      imageData = documentImagesMap[document.documentImageId]
    }
    // Try using the document ID as key
    else if (documentImagesMap[document.id]) {
      imageData = documentImagesMap[document.id]
    }
    // Check if this is a recently uploaded document (within last 5 minutes)
    else if (document.uploadDate) {
      const uploadTime = new Date(document.uploadDate)
      const now = new Date()
      const timeDiff = (now - uploadTime) / (1000 * 60) // difference in minutes

      if (timeDiff < 5) {
        // This is a recent upload, check for any available image data in the map
        const availableImages = Object.values(documentImagesMap)
        if (availableImages.length > 0) {
          // Use the most recent image data
          imageData = availableImages[availableImages.length - 1]
        }
      }
    }
    // Fallback to original avatar
    // else if (document.avatar && document.avatar !== "/api/placeholder/40/40") {
    if (
      !imageData &&
      document.avatar &&
      document.avatar !== "../../../images/profile-placeholder.jpg" &&
      document.avatar !== "../../../images/profile-placeholder.jpg"
    ) {
      imageData = document.avatar
    }

    // Clean the image data first
    if (imageData && typeof imageData === "string") {
      imageData = cleanBase64String(imageData)
      // console.log("Cleaned image data, removed metadata suffix")
    }

    // Validate and process the cleaned image data
    if (imageData) {
      // If it's already a valid data URL, return it
      if (isValidBase64Image(imageData)) {
        // console.log("Using valid base64 image data")
        return imageData
      }

      // If it's base64 without data URL prefix, add it
      if (typeof imageData === "string" && !imageData.startsWith("data:") && !imageData.startsWith("http")) {
        // Try to detect image format from the base64 header
        let mimeType = "image/jpeg" // default

        // Basic detection based on base64 header
        if (imageData.startsWith("iVBORw0KGgo")) {
          mimeType = "image/png"
        } else if (imageData.startsWith("/9j/")) {
          mimeType = "image/jpeg"
        } else if (imageData.startsWith("R0lGOD")) {
          mimeType = "image/gif"
        }

        const dataUrl = `data:${mimeType};base64,${imageData}`

        if (isValidBase64Image(dataUrl)) {
          // console.log("Created valid data URL from cleaned base64 string")
          return dataUrl
        }
      }

      // If it's a regular URL (http/https), return it
      if (typeof imageData === "string" && (imageData.startsWith("http") || imageData.startsWith("/"))) {
        // console.log("Using regular URL")
        return imageData
      }
    }

    console.log("No valid image data found, using placeholder")
    return PlaceHolderImage;
  }

  const isSelfieDocument = (document) => {
    // return document.categoryId === "selfie" || document.subType === "Selfie"
    const displayName = getSubtypeDisplayName()
    return displayName === "Selfie" || document.categoryId === "1"
  }

  const getStatusColor = (status) => {
    switch (status) {
      case "approved":
        return "success"
      case "rejected":
        return "error"
      case "pending":
        return "warning"
      case "expired":
        return "error"
      default:
        return "default"
    }
  }

  const getStatusIcon = (status) => {
    switch (status) {
      case "approved":
        return <CheckCircleIcon />
      case "rejected":
        return <CancelIcon />
      case "pending":
        return <AccessTimeIcon />
      case "expired":
        return <WarningIcon />
      default:
        return <AccessTimeIcon />
    }
  }

  const handleEdit = () => {
    setEditingDoc({ ...document, dateOfBirth:format(parseISO(user?.User?.dateofbirth), 'yyyy-MM-dd') })
    if (document.number || document.issueDate || document.expiryDate) {
      setShouldDisableAllFields(true)
    } else {
      setShouldDisableAllFields(false)
    }

    onEdit(document)
  }

  const handleSave = () => {
    console.log("editingDoc--------------",editingDoc);
    if (!validateFields()) return

    setEditingDoc((prevData) => ({
      ...prevData,
      imagedata: documentImageSrc
    }));

    setSubmittedEditData(editingDoc);
    // onSave(editingDoc)
    // setEditingDoc(null)
    setShowPinPad(true);
  }

  const handleConfirm = (event, pin) => {
    let PIN = pin.join('');
    onSave(PIN, editingDoc);
    setShowPinPad(false);
    setIsKycInfoAdded(true)
    setEditingDoc(null)
    onEdit(null);
  };

  const handleStatusUpdateConfirm = async(event, pin) => {
    let PIN = pin.join('');
    handleStatusUpdate(PIN);
    setShowPinPad(false);
  }

  const handleCancel = () => {
    setEditingDoc(null)
    onEdit(null)
  }

  const handleStatusUpdate = async(pin) => {
    console.log("document===============",document);
    console.log("pin===============",pin);
    console.log("SelectedStatus===============",selectedStatus);
    console.log("user===============",user?.User);
    console.log("rejectNote===============",rejectNoteContent);

    let statusToSend = selectedStatus == "pending" ? 1 : selectedStatus == "approved" ? 2 : selectedStatus == "rejected" ? 3 : selectedStatus == "expired" ? 4 : 1;
    console.log("statusToSend===============",statusToSend);
    setIsStatusUpdating(true);
    
    try {
      let response;
      if(activeTab == 0) {
        response = await userKYCStatusUpdate(agent?.User?.id, pin, document?.id, user?.User?.id, statusToSend, rejectNoteContent, user?.User?.kycpolicyid )
      } else {
        response = await merchantKYCStatusUpdate(agent?.User?.id, pin, document?.id, user?.User?.id, statusToSend, rejectNoteContent )
      }
      console.log("handleStatusUpdate_response===============",response);
      if(response?.data?.header?.callStatus == "1") {
        if (onStatusUpdate) {
          if(statusToSend == 4) {
            onMarkExpired(document.id)
          }
          setTimeout(() => {
            // console.log("onStatusUpdate_document===============",document);
            // console.log("onStatusUpdate_categoryId===============",document.categoryId);
            // console.log("onStatusUpdate_document.id===============",document.id);
            // console.log("onStatusUpdate_selectedStatus===============",selectedStatus);
            // console.log("onStatusUpdate_rejectNoteContent===============",rejectNoteContent);
            
            onStatusUpdate(document.categoryId, document.id, selectedStatus, rejectNoteContent);
            setSelectedStatus(null);
            setIsStatusUpdating(false);
          }, 2000);
          // onStatusUpdate(document.id, selectedStatus, document?.categoryId);
          setNotification({ open: true, message: "KYC status updated successfully", severity:"success" });
          setRejectNoteContent("");
          getUserKycData();
        }
      } else if (response?.Status == "2") {
        setIsStatusUpdating(false);
        setErrorAlert({
          header: 'Error',
          message: response?.payload?.msg,
          severity: 'error',
          showAlert: true
        });
      }
      setShowStatusUpdatePinPad(false);
    } catch (error) {
      console.log("handleStatusUpdate_error===============",error);
    }

  }

  const handleShowStatusUpdatePinPad = async(newStatus) => {
    setShowStatusUpdatePinPad(true);
    setSelectedStatus(newStatus);
  }

  const handleShowRejectedStatusUpdatePinPad = async(reason, newStatus) => {
    console.log("reason-------",reason);
    console.log("newStatus-------",newStatus);
    setRejectNoteContent(reason);
    setSelectedStatus(newStatus);
    setShowStatusUpdatePinPad(true);
  }

  const handleNotificationClose = () => {
    setNotification({ ...notification, open: false })
  }

  // const handleMarkAsExpired = async() => {
  //   try {
  //     const response = await userKYCStatusUpdate(agent?.User?.id, pin, document?.id, user?.User?.id, statusToSend )
  //     onMarkExpired(document.id)
  //   } catch (error) {
      
  //   }
  // }

  const handleViewImage = () => {
    setImageViewerOpen(true)
  }

  const currentDoc = editingDoc || document
  const displayName = getSubtypeDisplayName()
  const documentImageSrc = getDocumentImage()

  // console.log("DocumentCard - documentImageSrc:", documentImageSrc)
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Card
        sx={{
          mb: 2,
          border: (document.isExpired || document.status == "expired") ? "2px solid #f44336" : "1px solid #e0e0e0",
          opacity: (document.isExpired || document.status == "expired") ? 0.7 : 1,
        }}
      >
        <CardContent>
        
          <Alert severity="error" sx={{ mb: 2 }}>
            <Typography variant="body2">
              <strong>SECURITY:</strong> This is Personal Identifiable Information. The Data is confidential.
            </Typography>
          </Alert>

          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Box sx={{ textAlign: "center", mb: 2 }}>
                {/* <Avatar
                  src={document.avatar || "/api/placeholder/80/80"}
                  sx={{ width: 80, height: 80, mx: "auto", mb: 2 }}
                /> */}
                {/* <Avatar src={documentImageSrc} sx={{ width: 80, height: 80, mx: "auto", mb: 2 }} /> */}
                <Box
                  sx={{
                    width: 80,
                    height: 80,
                    mx: "auto",
                    mb: 2,
                    borderRadius: "50%",
                    overflow: "hidden",
                    border: "2px solid #e0e0e0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#f5f5f5",
                  }}
                >
                  <img
                    src={documentImageSrc || "/placeholder.svg"}
                    alt={`${displayName} document`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                    // onError={(e) => {
                    //   console.error("Image failed to load:", documentImageSrc)
                    //   e.target.src = "/api/placeholder/80/80"
                    // }}
                    // onLoad={() => {
                    //   console.log("Image loaded successfully:", documentImageSrc?.substring(0, 50) + "...")
                    // }}
                  />
                </Box>
                {/* {!isEditing ? (
                  <Button
                    variant="outlined"
                    startIcon={<EditIcon />}
                    onClick={handleEdit}
                    fullWidth
                    disabled={document.isExpired}
                  >
                    Add KYC Info
                  </Button>
                ) : (
                  <Stack spacing={1}>
                    <Button variant="outlined" onClick={handleCancel} fullWidth>
                      Cancel
                    </Button>
                    <Button variant="contained" onClick={handleSave} fullWidth>
                      Submit
                    </Button>
                  </Stack>
                )} */}

                {!isEditing && !isKycInfoAdded && !document.number && !document.issueDate && !document.expiryDate && document.categoryId !== "1" && (
                    <Button
                      variant="outlined"
                      startIcon={<EditIcon />}
                      onClick={handleEdit}
                      fullWidth
                      disabled={document.isExpired || document.status == "expired"}
                    >
                      Add KYC Info
                    </Button>
                  )}
                  {isEditing && (
                    <Stack spacing={1}>
                      <Button variant="outlined" onClick={handleCancel} fullWidth>
                        Cancel
                      </Button>
                      <Button variant="contained" onClick={handleSave} fullWidth>
                        Submit
                      </Button>
                    </Stack>
                  )}
              </Box>

              <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                Document Type:
              </Typography>
              <Typography variant="body1">
              {displayName}
              </Typography>
              {/* <TextField value={document.subType} variant="outlined" size="small" fullWidth disabled /> */}
              {/* <TextField value={displayName} variant="outlined" size="small" fullWidth disabled /> */}
            </Grid>

            <Grid item xs={12} md={8}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2, gap: 1, flexWrap: "wrap" }}>
                <IconButton size="small">
                  <VisibilityIcon onClick={handleViewImage} />
                </IconButton>
                <Chip
                  label={document.status}
                  color={getStatusColor(document.status)}
                  icon={getStatusIcon(document.status)}
                />
                <Chip
                  label="Pending"
                  color="warning"
                  variant={document.status === "pending" ? "filled" : "outlined"}
                  clickable
                  onClick={() => handleShowStatusUpdatePinPad("pending")}
                  // onClick={() => handleStatusUpdate("pending")}
                  disabled={document.isExpired}
                />
                <Chip
                  label="Accept"
                  color="success"
                  variant={document.status === "approved" ? "filled" : "outlined"}
                  clickable
                  onClick={() => handleShowStatusUpdatePinPad("approved")}
                  // onClick={() => handleStatusUpdate("approved")}
                  disabled={document.isExpired}
                />
                <Chip
                  label="Reject"
                  color="error"
                  variant={document.status === "rejected" ? "filled" : "outlined"}
                  clickable
                  onClick={() => setShowInputAlert((prevState) => ({
                    ...prevState,
                    showAlert: true,
                    severity: "confirm",
                    message: "Are you sure you want to reject this kyc document?",
                    header: "Reject Document?",
                    alertType: "confirm",
                    inputLabel: "Reason",
                    onConfirm: (reason) => {
                      handleShowRejectedStatusUpdatePinPad(reason, "rejected"); // Pass rowData directly
                    },
                }))}
                  // onClick={() => handleShowStatusUpdatePinPad("rejected")}
                  // onClick={() => handleStatusUpdate("rejected")}
                  disabled={document.isExpired}
                />
                <Typography variant="body2" color="textSecondary" sx={{ ml: "auto" }}>
                  Status: {document.status}
                </Typography>
              </Box>

              <Grid container spacing={2}>
                {!isSelfieDocument(document) && (
                  <>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Document Number:
                      </Typography>
                      {isEditing ? (
                        <TextField
                          value={currentDoc.number || ""}
                          onChange={(e) => setEditingDoc({ ...editingDoc, number: e.target.value })}
                          size="small"
                          fullWidth
                          required
                          error={!!validationErrors.number}
                          helperText={validationErrors.number}
                          disabled={isKycInfoAdded || shouldDisableAllFields}
                        />
                      ) : (
                        <Typography variant="body1">{document.number || "N/A"}</Typography>
                      )}
                    </Grid>
                  </>
                )}

                <Grid item xs={6}>
                  <Typography variant="body2" color="textSecondary">
                    Upload Date:
                  </Typography>
                  <Typography variant="body1">{document.uploadDate?.toLocaleDateString() || "N/A"}</Typography>
                </Grid>

                {/* Date of Birth Field - Always show for non-selfie documents */}
                {!isSelfieDocument(document) && (
                  <Grid item xs={6}>
                    <Typography variant="body2" color="textSecondary">
                      Date of Birth:
                    </Typography>
                    {isEditing ? (
                      <DatePicker
                        value={parseISO(user?.User?.dateofbirth)}
                        disabled={true}
                        // onChange={(date) => setEditingDoc({ ...editingDoc, dateOfBirth: date })}
                        renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                      />
                    ) : (
                      <Typography variant="body1">
                        {currentDoc?.dateOfBirth
                          ? new Date(currentDoc.dateOfBirth).toLocaleDateString()
                          : user?.User?.dateofbirth
                            ? new Date(user.User.dateofbirth).toLocaleDateString()
                            : "N/A"}
                      </Typography>
                      // <Typography variant="body1">
                      //   {
                      //     currentDoc?.dateOfBirth?.toLocaleDateString() || 
                      //     user?.User?.dateofbirth 
                      //     || "N/A"
                      //   }
                      // </Typography>
                    )}
                  </Grid>
                )}

                {!isSelfieDocument(document) && (
                  <>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Document Issue Date:
                      </Typography>
                      {isEditing ? (
                        <DatePicker
                          required
                          error={!!validationErrors.issueDate}
                          helperText={validationErrors.issueDate}
                          // value={currentDoc.issueDate}
                          value={currentDoc.issueDate ? new Date(currentDoc.issueDate) : null}
                          onChange={(date) => setEditingDoc({ ...editingDoc, issueDate: date })}
                          renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                          disabled={isKycInfoAdded || shouldDisableAllFields}
                        />
                      ) : (
                        <Typography variant="body1">{document.issueDate?.toLocaleDateString() || "N/A"}</Typography>
                      )}
                    </Grid>

                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Document Expiry Date:
                      </Typography>
                      {isEditing ? (
                        <DatePicker
                          required
                          error={!!validationErrors.expiryDate}
                          helperText={validationErrors.expiryDate}
                          disabled={isKycInfoAdded || shouldDisableAllFields}
                          // value={currentDoc.expiryDate}
                          value={currentDoc.expiryDate ? new Date(currentDoc.expiryDate) : null}
                          onChange={(date) => setEditingDoc({ ...editingDoc, expiryDate: date })}
                          renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                        />
                      ) : (
                        <Typography variant="body1">{document.expiryDate?.toLocaleDateString() || "N/A"}</Typography>
                      )}
                    </Grid>

                    {document.dateOfBirth && (
                      <Grid item xs={6}>
                        <Typography variant="body2" color="textSecondary">
                          Date of Birthhh:
                        </Typography>
                        {isEditing ? (
                          <DatePicker
                            value={currentDoc.dateOfBirth}
                            onChange={(date) => setEditingDoc({ ...editingDoc, dateOfBirth: date })}
                            renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                          />
                        ) : (
                          // <Typography variant="body1">{document.dateOfBirth?.toLocaleDateString() || "N/A"}</Typography>
                          <Typography variant="body1">
                            {document.dateOfBirth
                              ? new Date(document.dateOfBirth).toLocaleDateString()
                              : "N/A"}
                          </Typography>
                        )}
                      </Grid>
                    )}

                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Country:
                      </Typography>
                      {isEditing ? (
                        <FormControl fullWidth size="small">
                          <Select
                            required
                            error={!!validationErrors.country}
                            helperText={validationErrors.country}
                            value={currentDoc.country || ""}
                            disabled={isKycInfoAdded || shouldDisableAllFields}
                            onChange={(e) => {
                              const newCountry = e.target.value
                              
                              setEditingDoc({
                                ...editingDoc,
                                country: newCountry,
                                state: "", // Reset state when country changes
                              })
                            }}
                          >
                            {countries.map((country) => (
                              <MenuItem key={country.key} value={country.value}>
                                {country.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      ) : (
                        <Typography variant="body1">
                          {countries.find((c) => c.value === document.country)?.label || document.country || "N/A"}
                        </Typography>
                      )}
                    </Grid>

                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        State:
                      </Typography>
                      {isEditing ? (
                        <FormControl fullWidth size="small">
                          <Select
                            // required
                            // error={!!validationErrors.number}
                            // helperText={validationErrors.number}
                            disabled={isKycInfoAdded || shouldDisableAllFields}
                            value={currentDoc.state || ""}
                            onChange={(e) => setEditingDoc({ ...editingDoc, state: e.target.value })}
                          >
                            {availableStates?.map((state) => (
                              <MenuItem key={state.key} value={state.value}>
                                {state.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      ) : (
                        // <Typography variant="body1">{document.state || "N/A"}</Typography>
                        <Typography variant="body1">
                          {
                            // Find the state label based on document.state
                            availableStates?.find((state) => state.value == document.state)?.label || "N/A"
                            
                            // availableStates?.find((state) => {
                            //   console.log("state----------",state);
                            //   console.log("state---------22-",document.state);
                            // })
                          }
                        </Typography>
                      )}
                    </Grid>

                    {document?.status == "rejected" && <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Reject Notes: 
                      </Typography>
                      <Typography variant="" color="">
                        {document?.notes}
                      </Typography>
                    </Grid>}
                  </>
                )}

                {isSelfieDocument(document) && (
                  <Grid item xs={12}>
                    <Typography variant="body2" color="textSecondary" gutterBottom>
                      Selfie Verification
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                      This is a selfie verification image for identity confirmation.
                    </Typography>
                  </Grid>
                )}

                {isSelfieDocument(document) && (
                  <Grid item xs={6}>
                    <Typography variant="body2" color="textSecondary">
                      Reject Notes: 
                    </Typography>
                    <Typography variant="" color="">
                      {document?.notes}
                    </Typography>
                  </Grid>
                )}
              </Grid>

              <Box sx={{ mt: 2, display: "flex", gap: 1, flexWrap: "wrap" }}>
                <Button
                  variant="outlined"
                  color="error"
                  startIcon={<WarningIcon />}
                  onClick={() => handleShowStatusUpdatePinPad("expired")}
                  disabled={document.isExpired}
                  size="small"
                >
                  {document.isExpired ? "Expired" : "Mark as Expired"}
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<UploadIcon />}
                  // onClick={() => onUploadNew(document.subType)}
                  // onClick={() => onUploadNew(displayName)}
                  onClick={() => {
                    setSelectedSubTypeId(document.subType);
                    onUploadNew(displayName);
                  }}
                  size="small"
                >
                  {/* {isSelfieDocument(document) ? "Upload Another Selfie" : `Upload Another ${document.subType}`} */}
                  {isSelfieDocument(document) ? "Upload Another Selfie" : `Upload Another ${displayName}`}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <ImageViewerModal
        open={imageViewerOpen}
        onClose={() => setImageViewerOpen(false)}
        imageUrl={documentImageSrc}
        title={`${displayName} Document`}
      />

      <Snackbar
        open={notification.open}
        autoHideDuration={5000}
        onClose={handleNotificationClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleNotificationClose} severity={notification.severity} sx={{ width: "100%" }}>
          {notification.message}
        </Alert>
      </Snackbar>

      <CustomAlert
        severity={errorAlert.severity} 
        show={errorAlert.showAlert} 
        header={errorAlert.header} 
        message={errorAlert.message} 
        onClick={(prevDetails) => {
          setErrorAlert({...prevDetails, showAlert: false});
        }}
        autoclose={alert.severity === "error" ? false : true}
      />

      {showPinPad && 
        <PinPad
          show={showPinPad} 
          handleConfirm={handleConfirm} 
          onClick={() => setShowPinPad(false)} 
        />
      }

      {showStatusUpdatePinPad && 
        <PinPad
          show={showStatusUpdatePinPad} 
          handleConfirm={handleStatusUpdateConfirm} 
          onClick={() => setShowStatusUpdatePinPad(false)} 
        />
      }

      <CustomInputAlert
        show={showInputAlert?.showAlert}
        severity={showInputAlert?.severity}
        header={showInputAlert?.header}
        message={showInputAlert?.message}
        alertType={showInputAlert?.alertType}
        inputLabel={showInputAlert?.inputLabel}
        confirmButton={(value) => showInputAlert?.onConfirm(value)} 
        onClick={() => setShowInputAlert(false)}
        multiline={true}
      />
    </LocalizationProvider>
  )
}

export default DocumentCard
